import { createFileRoute, redirect } from '@tanstack/react-router';

// /reports opens the first fixed report (merchant screens §2 Redirects).
export const Route = createFileRoute('/reports/')({
  beforeLoad: () => {
    throw redirect({
      to: '/reports/$reportId',
      params: { reportId: 'conversations_by_channel_day' },
    });
  },
});
